import { HttpClient } from "@angular/common/http";
import { ApiService, HttpMethod } from "../api.service";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { Batch } from "./batch.model";
import { PagingResponse } from "../vendor/models/vendor-for-new-po.model";
import { PagingRequest } from "src/app/shared-api/models/paging.model";

@Injectable({
    providedIn: 'root'
})
export class BatchApiService extends ApiService
{
    constructor(protected http: HttpClient)
    {
        super(http);
    }

    getBatchesForLocation(locationId: number, options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.apiRequest<PagingResponse<Batch>>(this.getBatchesForLocationUrl(locationId, options), HttpMethod.Get)
            // .pipe(map(json => json.map(item => new Batch(item))));
    }
    getBatchesForSubsidiary(subsidiaryId: number, options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.apiRequest<PagingResponse<Batch>>(this.getBatchesForSubsidiaryUrl(subsidiaryId, options), HttpMethod.Get)
            // .pipe(map(json => json.map(item => new Batch(item))));
    }
    getAllBatches(options?: PagingRequest): Observable<PagingResponse<Batch>> {
        return this.apiRequest<PagingResponse<Batch>>(this.getAllBatchesUrl(options), HttpMethod.Get)
            // .pipe(map(json => json.map(item => new Batch(item))));
    }

    addBatch(batch: Batch): Observable<Batch> {
        return this.apiRequest<Batch>(this.addBatchUrl, HttpMethod.Post, JSON.stringify(batch))
            .pipe(map(json => new Batch(json)))
    }

    deleteBatch(batchId: number): Observable<any> {
        return this.apiRequest<any>(this.deleteBatchUrl(batchId), HttpMethod.Delete);
    }
    
    updateBatch(model: Batch): Observable<Batch> {
        let body = {
            status: model.status,
            number: model.number,
            notes: model.notes,
            isDefault: model.isDefault
        };
        return this.apiRequest<any>(this.updateBatchUrl(model.id), HttpMethod.Put, JSON.stringify(body));
    }

    private get baseUrl(): string { return this.baseApiUrl + 'batches' }
    private get addBatchUrl(): string { return this.baseUrl; }
    private deleteBatchUrl(batchId: number): string { return this.baseUrl + '/' + batchId; }
    private updateBatchUrl(batchId: number): string { return this.baseUrl + '/' + batchId; }
        private getBatchesForLocationUrl(locationId: number, options?: PagingRequest) { 
        let url = this.baseUrl + '/location/' + locationId; 
        if(!options)
            return url;

        url = url + '?' + this.buildPagingRequest(options); 
        return url;
    }
    private getBatchesForSubsidiaryUrl(subsidiaryId: number, options?: PagingRequest) { 
        let url = this.baseUrl + '/subsidiary/' + subsidiaryId; 
        if(!options)
            return url;

        url = url + '?' + this.buildPagingRequest(options); 
        return url;
    }
    private getAllBatchesUrl(options?: PagingRequest) { 
        let url = this.baseUrl; 
        if(!options)
            return url;

        url = url + '?' + this.buildPagingRequest(options); 
        return url;
     }
}